import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../firebase";

const functions = getFunctions(app, "asia-southeast1");

type FinalizeSubmissionPayload = {
  submissionId?: string;
};

type FinalizeSubmissionResult = {
  success: boolean;
  action?: string;
  leadId?: string;
  submissionId?: string;
};

const finalizePendingUecSubmissionsCallable = httpsCallable<
  FinalizeSubmissionPayload,
  FinalizeSubmissionResult
>(functions, "finalizePendingUecSubmissions");

const finalizePendingSpmSubmissionsCallable = httpsCallable<
  FinalizeSubmissionPayload,
  FinalizeSubmissionResult
>(functions, "finalizePendingSpmSubmissions");

export async function finalizePendingUecSubmission(submissionId?: string) {
  const result = await finalizePendingUecSubmissionsCallable({
    submissionId: submissionId || "",
  });
  return result.data;
}

export async function finalizePendingSpmSubmission(submissionId?: string) {
  const result = await finalizePendingSpmSubmissionsCallable({
    submissionId: submissionId || "",
  });
  return result.data;
}

export async function finalizePendingLandingPageSubmissions() {
  const finalizers = [
    {
      name: "finalizePendingSpmSubmissions",
      run: () => finalizePendingSpmSubmission(),
    },
    {
      name: "finalizePendingUecSubmissions",
      run: () => finalizePendingUecSubmission(),
    },
  ];

  const results = await Promise.allSettled(
    finalizers.map((finalizer) => finalizer.run()),
  );

  results.forEach((result, index) => {
    if (result.status === "rejected") {
      console.warn(
        `${finalizers[index].name} did not complete after login.`,
        result.reason,
      );
    }
  });
}
